import { stringifyUrl } from "query-string";
import { IApiResourceResponse } from "../../@typings/client";
import { StudentProfileInfo } from "../typings/Profiles";
import { UsersLoader } from "./UsersLoader";
import { ProfilesQuery } from "./ProfilesApi";

export class ProfilesStudentsApi {
  public static updateStudentProfile(
    id: string,
    data: IApiResourceResponse<StudentProfileInfo>,
    query: ProfilesQuery = {}
  ) {
    const url = stringifyUrl({ url: `/users_profiles_students/${id}`, query }, { arrayFormat: "comma" });
    return UsersLoader.patch({ url, data });
  }
}
